//
//
//
//
//
//
//

import DetailInfosection from '~/components/detail/desktop/detail_infosection'
import DetailMoreInfosection from '~/components/detail/desktop/detail_more_infosection'
export default {
  name: 'CoinDetail',
  components: { DetailInfosection, DetailMoreInfosection },
  props: {
    data: {
      type: Object,
      default: null
    },
    tetherData: {
      type: Object,
      default: null
    }
  }
}
